import React from "react";
import { SkeletonBox, SkeletonText, SkeletonCard } from "./SkeletonBox";

/**
 * ArtistPageSkeleton - Non-animated skeleton for Artist page
 * 
 * Matches layout of:
 * - artist/content.js (Back button, avatar, artist names, description, movies grid)
 */

function skeletonElement(className) {
  return function SkeletonElement(props) {
    var mergedClassName = className + (props.className ? " " + props.className : "");
    return <div {...props} className={mergedClassName} />;
  };
}

var Container = skeletonElement("legacy-skeleton-page-container");
var HeaderRow = skeletonElement("legacy-skeleton-inline-row legacy-skeleton-header-row");
var BackButtonSkeleton = skeletonElement("legacy-skeleton-back-button");
var ArtistInfoSection = skeletonElement("legacy-skeleton-inline-row legacy-skeleton-artist-info");
var ArtistTextSection = skeletonElement("legacy-skeleton-artist-text");
var ContentGrid = skeletonElement("legacy-skeleton-wrap-row legacy-skeleton-artist-grid");
var CardWrapper = skeletonElement("legacy-skeleton-artist-card-wrap");

/**
 * Header with back button
 */
function HeaderSkeleton() {
    return (
        <HeaderRow>
            <BackButtonSkeleton />
        </HeaderRow>
    );
}

/**
 * Artist avatar and info skeleton
 */
function ArtistInfoSkeleton() {
    return (
        <ArtistInfoSection>
            {/* Circular avatar - 196x196 matching content.js */}
            <SkeletonBox width={196} height={196} circle />

            {/* Artist text info */}
            <ArtistTextSection>
                {/* Farsi name - h5 */}
                <SkeletonText width={180} size="xl" style={{ marginBottom: 8 }} />
                {/* English name - h5 */}
                <SkeletonText width={140} size="lg" style={{ marginBottom: 16 }} />
                {/* Description - smaller text */}
                <SkeletonText width={300} size="md" />
            </ArtistTextSection>
        </ArtistInfoSection>
    );
}

/**
 * Movies grid skeleton
 */
function MoviesGridSkeleton({ rows = 1, cols = 5 }) {
    var cards = [];
    var total = rows * cols;

    for (var i = 0; i < total; i++) {
        cards.push(
            <CardWrapper key={"card_" + i}>
                <SkeletonCard type="portrait" />
            </CardWrapper>
        );
    }

    return (
        <ContentGrid>
            {cards}
        </ContentGrid>
    );
}

/**
 * ArtistPageSkeleton - Main export
 * @param {number} rows - Number of movie rows to show
 * @param {number} cols - Number of columns per row
 */
function ArtistPageSkeleton({ rows = 1, cols = 5 }) {
    return (
        <Container>
            <HeaderSkeleton />
            <ArtistInfoSkeleton />
            <MoviesGridSkeleton rows={rows} cols={cols} />
        </Container>
    );
}

export { HeaderSkeleton, ArtistInfoSkeleton, MoviesGridSkeleton };
export default ArtistPageSkeleton;
